import { Component } from '@angular/core';
/* import { NavController, NavParams } from 'ionic-angular'; */
import { NavController, NavParams, ViewController, AlertController } from 'ionic-angular';

/*
  Generated class for the Login page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
  selector: 'page-login',
  templateUrl: 'login.html'
})
export class LoginPage {
    
  constructor(private nav:NavController, private viewCtrl:ViewController, private alertController: AlertController) {}
  
  ionViewDidLoad() {
    console.log('ionViewDidLoad LoginPage');
  }
  
  closeMe() {
    let confirm = this.alertController.create({
      title: 'Close Me?',
      buttons: [
        {
          text: 'Yes',
          handler: () => {
            this.viewCtrl.dismiss();
          }
        },
        {
          text: 'No'
        }
      ]
    });
    
    confirm.present(confirm);
  }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts